import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {EquipmentCardEnums} from '@namespaces/equipment.namespace';
import {SelectValueInterface} from '@interfaces/select-value.interface';

@Injectable()
export class EquipmentStatusesProvider {
    public data$ = new BehaviorSubject<SelectValueInterface[]>([
        {id: EquipmentCardEnums.EquipmentStatus.working,        title: 'Исправно / В работе'},
        {id: EquipmentCardEnums.EquipmentStatus.conservation,   title: 'Консервация'},
        {id: EquipmentCardEnums.EquipmentStatus.repair,         title: 'Не исправно / На ремонте'},
        {id: EquipmentCardEnums.EquipmentStatus.dismiss,        title: 'Списано'},
    ]);
}
